import {Component, Inject} from "@angular/core";
import {FormComponent} from "../renderer/model/form-component";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {COMPONENT_TYPES_REGISTRY} from "../renderer/model/registry";

@Component({
    selector: "edit-form-component",
    templateUrl: './edit.form.component.html'
})
export class EditFormComponent {

    constructor(public dialogRef: MatDialogRef<EditFormComponent>, @Inject(MAT_DIALOG_DATA) public formComponent: FormComponent) {}

    onNoClick(): void {
        this.dialogRef.close();
    }

    allowsValidators(): boolean {
        return COMPONENT_TYPES_REGISTRY.get(this.formComponent.type).allowsData;
    }
}
